export const movieActionTypes = {
    search: 'movie@search',
    filter: 'movie@filter',
    popular: 'movie@popular',
};

export const userActionTypes = {
    addUser: 'user@addUser',
    removeUser: 'user@removeUser',
};
